import React from 'react';
import PropTypes from 'prop-types';
import TimeHelpers from '@arreeba/ristoranti-frontend-lib/lib/helpers/time';

const BookingDateRow = ({ date, open, slots, hasAvailableSpots, onClick, hasBookingRushes }) => {
  const locale = 'it';
  const isBookable = (slots !== null) && (slots.length > 0) && hasAvailableSpots;

  return (
    <li className="bookingDateRow">
      <button onClick={e => e.preventDefault() & onClick({ date, hasBookingRushes, slots})}>
        <div className="title">{TimeHelpers.toLocalDate(date, locale)}</div>
        <p>{TimeHelpers.weekDayLocale(date, locale)}</p>

        {!open && <div className="not-available">Chiuso</div>}
        {!isBookable && open && <div className="not-available">Non ci sono posti disponibili</div>}
        <i className="bi_interface-right" />
      </button>
    </li>
  );
};

BookingDateRow.propTypes = {
  date: PropTypes.string.isRequired,
  open: PropTypes.bool,
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      open: PropTypes.string,
      close: PropTypes.string,
      availableSpots: PropTypes.number,
      totalSpots: PropTypes.number,
    }),
  ),
  hasAvailableSpots: PropTypes.bool,
  hasBookingRushes: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default BookingDateRow;



// WEBPACK FOOTER //
// ./src/components/booking-date-row.js